import React from 'react';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { contactConfig, offerConfig } from '../data/siteConfig';
const FOOTER_POINTS = ['5 módulos + Módulo VIP + 3 bonos', '+240 páginas de contenido práctico', 'Llega a tu mail en minutos', `Garantía de ${offerConfig.guaranteeDays} días`];
export const FooterSection = () => {
  return <footer className="bg-familia-footer py-12 md:py-16 px-4 md:px-6" data-id="element-88" data-mp="3cah5tbfymn6b">
      <div className="max-w-7xl mx-auto w-full" data-id="element-89" data-mp="2ol4y6g0a6n64">
        <div className="flex flex-col items-center text-center mb-8 md:mb-10" data-id="element-90" data-mp="2kii56brviw7c">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-[15px] text-familia-onDarkMuted mb-8" data-id="element-91" data-mp="2kgf5f00x5opf">
            {FOOTER_POINTS.map(p => <li key={p} className="flex items-center gap-2" data-id="element-92" data-mp="2tiofjos9zg2a">
                <CheckIcon className="w-4 h-4 text-familia-checkDark" strokeWidth={3} aria-hidden="true" data-id="element-93" data-mp="2th3kzz5ynx4f" />
                {p}
              </li>)}
          </ul>
          <div className="flex flex-col mb-6" data-id="element-94" data-mp="20thk4yo4b6l9">
            <span className="text-familia-accent font-display text-2xl sm:text-3xl font-bold leading-tight" data-id="element-95" data-mp="20sogw7odaz7v">
              📚 VITALIDAD 360™
            </span>
            <span className="text-familia-onDarkMuted text-[13px] sm:text-sm font-semibold tracking-widest uppercase mt-1" data-id="element-96" data-mp="1lehz1d7x6je3">
              Master Kit Adultos Mayores
            </span>
          </div>
          <p className="flex items-center gap-2 text-[16px] text-white" data-id="element-97" data-mp="1v4b2fqxwrs79">
            <MessageCircleIcon className="w-5 h-5 text-familia-onDarkMuted" aria-hidden="true" data-id="element-98" data-mp="xinfrxr98o8x" />
            Soporte por WhatsApp:{' '}
            <span className="font-bold" data-id="element-99" data-mp="12hgqjif5q15e">{contactConfig.whatsappNumber}</span>
          </p>
        </div>
        <div className="w-full h-px bg-familia-darkBorder mb-10" data-id="element-100" data-mp="17eqeetmwe4r4" />
        <div className="max-w-4xl mx-auto space-y-5 text-center text-[13px] sm:text-[14px] text-familia-onDarkMuted leading-relaxed" data-id="element-101" data-mp="1biof38rvfnma">
          <p data-id="element-102" data-mp="2iuxa3h403agq">
            © VITALIDAD 360™ 2026 — Todos los derechos reservados. Prohibida
            la reproducción sin autorización expresa.
          </p>
          <p data-id="element-103" data-mp="nr8ydncrbhjl">
            VITALIDAD 360™ es un producto digital educativo para familias,
            cuidadores y profesionales que acompañan adultos mayores. No brinda
            diagnóstico ni tratamiento médico y no reemplaza la consulta con
            profesionales de la salud. Antes de iniciar rutinas de ejercicio,
            alimentación o cuidado, se recomienda consultar con un profesional,
            especialmente si el adulto mayor tiene condiciones médicas,
            movilidad reducida o antecedentes de caídas. Los resultados pueden
            variar según cada persona, su constancia y acompañamiento.
          </p>
        </div>
      </div>
    </footer>;
};